import { render, staticRenderFns } from "./SafetyCheckBasicInfo.vue?vue&type=template&id=8b26c0f6&scoped=true&"
import script from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js&"
export * from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b26c0f6",
  null
  
)

export default component.exports